export class VoyageFuelPrice {
    voyageNumber: number;
    hfoPrice?: number;
    mgoPrice?: number;
    hfoOnlyPrice?: number;
    lsfOnlyPrice?: number;
    bioPrice?: number;
    startDateTime?: Date;
    endDateTime?: Date;

    constructor(
        voyageNumber: number,
        hfoPrice?: number,
        mgoPrice?: number,
        hfoOnlyPrice?: number,
        lsfOnlyPrice?: number,
        bioPrice?: number,
        startDateTime?: Date,
        endDateTime?: Date
    ) {
        this.voyageNumber = voyageNumber;
        this.hfoPrice = hfoPrice;
        this.mgoPrice = mgoPrice;
        this.hfoOnlyPrice = hfoOnlyPrice;
        this.lsfOnlyPrice = lsfOnlyPrice;
        this.bioPrice = bioPrice;
        this.startDateTime = startDateTime;
        this.endDateTime = endDateTime;
    }
}
